import { graphql } from "../../gql";

export const UserOneOnOneClassroomPlanFragment = graphql(`
  fragment UserOneOnOneClassroomPlan on User1on1ClassroomPlanGraphqlDto {
    id
    userId
    createdAt
    startDateUtc
    endDateUtc
    lessonsPerWeek
    numberOfWeeks
    oneOnOneLessonType
    businessEnglishObjective
    lastLessonDateUtc
    speakingLevel
  }
`);
